import { render } from "./BizSearch.vue?vue&type=template&id=7714f2ac&ts=true"
import script from "./BizSearch.vue?vue&type=script&lang=ts"
export * from "./BizSearch.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__